import {Device} from './device';
import {Decoder} from './decoder';
import {Encoder} from './encoder';
import {DefaultDecoder} from './default-decoder';
import {DefaultEncoder} from './default-encoder';

export class IntegrationModule {
  integrationIdentifier: string;
  integrationCode: string;
  additionalInfo: string;
  technicalDetails: any;
  device: Device;
  decoder: Decoder | DefaultDecoder;
  encoder?: Encoder | DefaultEncoder;
}
